import { render } from "./ImportJobFailuresModal.vue?vue&type=template&id=dc60fdd6&scoped=true"
import script from "./ImportJobFailuresModal.vue?vue&type=script&lang=js"
export * from "./ImportJobFailuresModal.vue?vue&type=script&lang=js"

import "./ImportJobFailuresModal.vue?vue&type=style&index=0&id=dc60fdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc60fdd6"]])

export default __exports__